import Api, {validToken} from 'services';

// ACTION TYPES
export const scheduleHasErrored = () => ({type: '[SCHEDULE] HAS_ERRORED'});
export const scheduleIsLoading = () => ({type: '[SCHEDULE] IS_LOADING'});
export const scheduleFetchSuccess = data => ({type: '[SCHEDULE] FETCH_SUCCESS', data});
export const scheduleFetchSuccessPeriod = data => ({type: '[SCHEDULE] FETCH_SUCCESS_PERIOD', data});
export const scheduleFetchSuccessLote = data => ({type: '[SCHEDULE] FETCH_SUCCESS_LOTE', data});
export const scheduleIsLoadingForecast = () => ({type: '[SCHEDULE] IS_LOADING_FORECAST'});
export const scheduleFetchSuccessForecast = data => ({type: '[SCHEDULE] FETCH_SUCCESS_FORECAST', data});
export const scheduleFetchSuccessContador = data => ({type: '[SCHEDULE] FETCH_SUCCESS_CONTADOR', data});

// ACTION CREATORS
export const schedule_get_all_filters = () => dispatch => {
    //validToken();
    dispatch(scheduleIsLoading());
    Api.Schedule.getAllSkus({})
        .then(data => dispatch(scheduleFetchSuccess(data)))
        .catch(() => dispatch(scheduleHasErrored()));
};


export const schedule_get_rows_forecast = (filtros) => async dispatch => {
    //await validToken();
    dispatch(scheduleIsLoading());
    Api.Schedule.getRowsForecast(filtros)
        .then(data => dispatch(scheduleFetchSuccess(data)))
        .catch(() => dispatch(scheduleHasErrored()));
};

export const schedule_get_all_cost_center = () => dispatch => {
    // validToken();
    dispatch(scheduleIsLoading());
    Api.Schedule.getCostCenter()
        .then(data => dispatch(scheduleFetchSuccess(data)))
        .catch(() => dispatch(scheduleHasErrored()));
};

export const schedule_get_all_period = () => dispatch => {
    dispatch(scheduleIsLoading());
    Api.Schedule.getPeriod()
        .then(data => dispatch(scheduleFetchSuccessPeriod(data)))
        .catch(() => dispatch(scheduleHasErrored()));
};

export const schedule_set_forecast = (valor_antigo,valor,data_corrente) => async dispatch => {
    //validToken();
    dispatch(scheduleIsLoadingForecast());
    await Api.Schedule.setForecast(valor_antigo,valor,data_corrente)
        .then(data => dispatch(scheduleFetchSuccessForecast(data)))
        .catch(() => dispatch(scheduleHasErrored()));
};


export const schedule_get_rows_table = (skip) => dispatch => {
    //validToken();
    dispatch(scheduleIsLoading());
    Api.Schedule.getFilterPlanejamentoQuantidade({skip})
        .then(data => dispatch(scheduleFetchSuccess(data)))
        .catch(() => dispatch(scheduleHasErrored()));
};

export const schedule_get_rows_table_count = () => dispatch => {
    //validToken();
    dispatch(scheduleIsLoading());
    Api.Schedule.getFilterPlanejamentoQuantidadeContador({})
        .then(data => dispatch(scheduleFetchSuccessContador(data)))
        .catch(() => dispatch(scheduleHasErrored()));
};

export const schedule_set_valores_lote = (valor) => dispatch => {
    //validToken();
    dispatch(scheduleIsLoading());
    Api.Schedule.setPlanejamentoQuantidadeLote({valor})
        .then(data => dispatch(scheduleFetchSuccessLote(data)))
        .catch(() => dispatch(scheduleHasErrored()));
};

export const schedule_set_valores_unitario = (valor) => async dispatch => {
    // validToken();
    dispatch(scheduleIsLoading());
    //console.log(valor);
    await Api.Schedule.setPlanejamentoQuantidadUnitario({valor})
        .then(data => dispatch(scheduleFetchSuccessLote(data)))
        .catch(() => dispatch(scheduleHasErrored()));
};
